import client from "./client";

// 상품 이미지는 admin 모듈(관리자 사이트)이 상품ID 기준으로 서빙한다(정적 파일 경로가 아니라
// productId/optionId 로 조회하는 API). <img> 태그로 불러오는 것은 CORS 제약이 없어 별도 설정 없이
// 그대로 사용 가능하다.
const ADMIN_BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL || "http://localhost:9082";

export function productMainImageUrl(productId) {
  return `${ADMIN_BASE_URL}/admin/product/${productId}/image/main`;
}

export function productThumbnailImageUrl(productId) {
  return `${ADMIN_BASE_URL}/admin/product/${productId}/image/thumbnail`;
}

export function productDetailImageUrl(detailImageId) {
  return `${ADMIN_BASE_URL}/admin/product/detail-image/${detailImageId}/view`;
}

export function productOptionImageUrl(optionId) {
  return `${ADMIN_BASE_URL}/admin/product/option/${optionId}/image`;
}

/** 상품 목록 (판매중 상품만). params: { pageNo, pageSize, categoryId, searchKeyword } */
export async function getProducts(params = {}) {
  const res = await client.get("/product", { params });
  return res.data;
}

export async function getProduct(productId) {
  const res = await client.get(`/product/${productId}`);
  return res.data;
}
